export default "__VITE_ASSET__lZCLQ_$H__"